const numberFormat = (value, precision=2) =>
{
	if ( typeof(value) !== 'number' )
	{
		value = new Number( ( value || '0' ).toString() )
	}

	if ( typeof(value.toLocaleString) === 'function' )
	{
		return value.toLocaleString(undefined, { minimumFractionDigits: precision, maximumFractionDigits: precision })
	}

	return value.toFixed(precision)
}

export default numberFormat